//
//
//
//
//
//
//
//
//

import PageMixin from '~/mixins/page'

export default {
  mixins: [PageMixin],
  data () {
    return {
      showFloatingButton: false
    }
  },
  head () {
    return this.createSeoTags({
      title: this.$t('gifts.seo.title'),
      description: this.$t('gifts.seo.description'),
      url: 'https://get-base.com/gifts',
      link: [
        {
          rel: 'preload',
          as: 'image',
          href: this.getStaticsObject('/gifts/header.webp')
        },
        {
          rel: 'preload',
          as: 'image',
          href: this.getStaticsObject('/gifts/header_mobile.webp')
        }
      ]
    })
  },
  async mounted () {
    await this.$store.dispatch('product/resetProducts')
    await this.$store.dispatch('product/setIsGift', true)
  }
}
